module.exports = __webpack_public_path__ + "img/298.bae1e6a5.jpg";